export const marquee = () => {
    document.querySelectorAll('span').forEach(el => {
        replaceTag(el, 'marquee');
    });
};
const replaceTag = (originalElement, newTag) => {
    const newElement = document.createElement(newTag);
    while (originalElement.firstChild) {
        newElement.appendChild(originalElement.firstChild);
    }
    for (let index = originalElement.attributes.length - 1; index >= 0; --index) {
        newElement.attributes.setNamedItem(originalElement.attributes[index]?.cloneNode());
    }
    originalElement.parentNode?.replaceChild(newElement, originalElement);
};
//# sourceMappingURL=fun.js.map